import { LockOutlined } from '@mui/icons-material'
import { styled, Typography } from '@mui/material'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { BottomDrawer } from '$common/bottom-drawer'
import { t } from '$i18n'
import { PrimaryButton } from '$common/buttons'
import { PackageLimitReachedType } from './types'

export interface Props {
  isOpen?: boolean
  type: PackageLimitReachedType
}

export function PackageLimitReached({ isOpen = false, type }: Props) {
  return (
    <BottomDrawer isOpen={isOpen} onClose={closeCurrentModal}>
      <Root>
        <IconContainer sx={{ mb: '32px' }}>
          <LockOutlined sx={{ width: 48, height: 48, color: 'inherit' }} />
        </IconContainer>
        <Typography textAlign="center" variant="h2" sx={{ mb: '16px' }}>
          {t(`packageLimitReachedModal.types.${type}.title`)}
        </Typography>
        <Typography textAlign="center" variant="paragraph1" sx={{ mb: '16px' }}>
          {t(`packageLimitReachedModal.types.${type}.description`)}
        </Typography>
        <PrimaryButton
          fullWidth
          variant="contained"
          color="primary"
          onClick={closeCurrentModal}
          text={t('callRoomIsFullDialog.submitText')}
        />
      </Root>
    </BottomDrawer>
  )
}

const Root = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 24px 16px;
`

const IconContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.error100};
  color: ${({ theme }) => theme.palette.error500};
`
